
<div class="modal-custom">
  <div class="modal-header">
    <h4 class="modal-title"><span class="ml-2">Delete Parameters</span></h4>
    <button type="button" class="close" data-dismiss="modal" (click)="close()">×</button>
  </div>


  <div class="modal-body">
    <div><div class="font-weight-bold">This will delete all the selected parameters.</div>
    <div >Are you sure you want delete the<font color="red"><strong> {{deleteCount.deleteCount}} </strong></font>checked parameter(s)?</div>
  </div>
  <div class="modal-footer mt-4">
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="deleteParameter()">Delete</button>
    <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="close()">Cancel</button>
  </div>
</div>
</div>
